<template>
  <section>
    <div v-if="user" class="userData container">
      <div class="userHead">
        <img :src="user.headImg||defaultHeadImg"/>
      </div>
      <div class="userName">{{user.userName}}</div>
      <div class="focus">
        <div class="btn" @click="addFocus()" @mouseenter="focusMsg='取消关注'" @mouseleave="focusMsg='已关注'"
             v-if="role === 'other' && user.isFocus >= 0 && user.isFocus%2 === 1">{{focusMsg}}</div>
        <div class="btnNo" @click="addFocus()" v-if="role === 'other' && user.isFocus >= 0 && user.isFocus%2 === 0">+&nbsp;关注</div>
      </div>
    </div>
    <div v-if="user" class="homeTab container">
      <div class="tab">
        <div class="item" @click="clickTab('focus')" :class="activeTab === 'focus'?'active':''">
          <div class="label">关注</div>
          <div class="num">{{user.focusNum}}</div>
        </div>
        <div class="item" @click="clickTab('follow')" :class="activeTab === 'follow'?'active':''">
          <div class="label">粉丝</div>
          <div class="num">{{user.followerNum}}</div>
        </div>
        <!--<div class="item">
          <div class="label">访客</div>
          <div class="num">100</div>
        </div>-->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    user: {
      'userId': '402888c563f7211f0163f721b2d10000',
      'userPhone': '15902059569',
      'passWord': '0A1BAB267B4603F4',
      'accesstoken': '5fda383f-44ca-4e38-9068-69e5b3a8988f',
      'userName': '用户9569',
      'sex': null,
      'birthday': null,
      'address': null,
      'signName': null,
      'articleNum': 18,
      'focusNum': 2,
      'followerNum': 1,
      'score': 124,
      'comeWay': 'WX',
      'headImg': null,
      'createTime': 1528859570000,
      'lastLoginTime': 1532333754000
    },
    activeTab: {
      type: String,
      default: ''
    },
    role: {
      type: String,
      default: 'self'
    }
  },
  inject: ['reload'],
  data () {
    return {
      focusMsg: '已关注',
      defaultHeadImg: require('../../../assets/image/installer.png')
    }
  },
  methods: {
    addFocus: function () {
      let that = this
      that.isLoad = true
      that.axios.post('/user/follow', {
        fromId: that.$root.getUserId(),
        toId: this.user.userId,
        flag: (this.user.isFocus % 2 === 0)
      }, {
        emulateJSON: true
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          that.user.isFocus += 1
          that.reload()
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    clickTab: function (tab) {
      this.$emit('changeTab', tab)
    }
  },
  mounted: function (s) {
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style scoped>
.userData {
  background-color: #0AB878;
  padding: 80px 0;
}
.userData img {
  width: 119px;
  height: 119px;
  border: 6px solid #FFFFFF;
  border-radius: 50%;
}
.userData .userName {
  padding-top: 20px;
  font-size: 23px;
  color: #FFFFFF;
}
.homeTab {
  background-color: #FFFFFF;
}
.tab {
  width: 600px;
  margin: 0 auto;
  display: flex;
  padding: 10px 0;
}
.tab .active {
  color: #05b570;
}
.tab .item {
  flex: 1;
  float: left;
  line-height: 25px;
  cursor: pointer;
}
.tab .item:nth-child(1) {
  border-right: 1px solid #F0F0F0;
}
.tab .item .label {
  font-size: 14px;
}
.tab .item .num {
  font-size: 20px;
  font-family: "SourceHanSansCN-Normal";
}
.userData .focus {
  width: 100%;
}
.userData .btn, .userData .btnNo {
  width: 89px;
  height: 30px;
  margin: 0 auto;
  margin-top: 10px;
  text-align: center;
  line-height: 30px;
  color: #fff !important;
  border-radius: 30px;
  border: 1px solid #0AB878;
  /*background-color: linear-gradient(to right, red , blue);*/
  background: linear-gradient(to right, #ffc234 , #ff9a35);
  cursor: pointer;
}
.userData .btnNo {
  color: #000000;
  background-color: #F0F0F0;
}
</style>



// WEBPACK FOOTER //
// src/components/user/base/homeTitle.vue